import { useContext } from "react";
import { Context } from "../components/tps/TpsContext";

const useTpsContext = () => {
  const { tpsContext, setTpsContext } = useContext(Context);
  let finalContextAnswers = tpsContext.answers ? [...tpsContext.answers] : [];
  let childQuestions = [];
  const pushAnswer = (questionId, answer, isCountry, answersToDelete) => {
    const ans = {
      questionId,
      answer: answer
    }

    if(answersToDelete && answersToDelete.length>0){
      childQuestions = answersToDelete.filter( child => child.idQuestionDepends === questionId );
    }

    if(isCountry && tpsContext.country !== ans.answer && answersToDelete && answersToDelete.length>0){
      finalContextAnswers = finalContextAnswers.filter( ans => !answersToDelete.some(answerDelete => ans.questionId ===answerDelete.id) );      
    }

    if(childQuestions && childQuestions.length>0){
      finalContextAnswers = finalContextAnswers.filter( ans => !childQuestions.some(childQ => ans.questionId === childQ.id) );
    }

 
    const tmpId = finalContextAnswers ? finalContextAnswers.findIndex(a => parseInt(a.questionId) === parseInt(questionId)) : -1;
    if (tmpId >= 0) {
      if(ans && ans.answer.length> 0){
        finalContextAnswers[tmpId] = ans;
        setTpsContext({
          ...tpsContext,
          country: isCountry? answer: tpsContext.country,
          answers : [...finalContextAnswers]
        })
      }else{
        popAnswer(questionId)
      }
    } else {
      setTpsContext({
        ...tpsContext,
        answers: Array.isArray(finalContextAnswers) ? [...finalContextAnswers, ans] : [ans],
        country: isCountry? answer: tpsContext.country
      });
    }  
  };

  const pushResponseName=(newResponseName)=>{ 
    setTpsContext({
      ...tpsContext,
      responseName: newResponseName
    }) 
  }

  const popAnswer = (questionId) => {
    const newAns = Array.isArray(tpsContext.answers) ? tpsContext.answers.filter(a => a.questionId !== questionId) : [tpsContext.answers];
    setTpsContext({
      ...tpsContext,
      answers: newAns
    })
  }
 
  const updateSuppliersArray = (array) => {
    if (Array.isArray(array)) {
      setTpsContext({
        ...tpsContext,
        suppliers: [...array]
      });
    }
  }

  const updatePartsArray = (array) => {
    if (Array.isArray(array)) {
      setTpsContext({
        ...tpsContext,
        parts: [...array]
      });
    }
  }

  const updateContext = (newTpsContext) => {
    let newContext = newTpsContext;
    if(newContext){
      let suppliers = newTpsContext.assignments && newTpsContext.assignments.length > 0? newTpsContext.assignments.map(it=>it.supplierNumber):[];
      newContext = {...newTpsContext};
      newContext.suppliers = suppliers;
    }else{
        newContext = {
          suppliers:[], 
          answers:[],
          assignments:[],
          errors:[], 
          country:null,
          parts:[],
          campaignId:null,
          tpsResponseSelected:null,
          responseName:null
      }
    }
    setTpsContext(newContext);
  }

  return { answers: tpsContext.answers, suppliers: tpsContext.suppliers, parts: tpsContext.parts, responseName : tpsContext.responseName, assignments : tpsContext.assignments, tpsResponseSelected : tpsContext.tpsResponseSelected, pushAnswer, popAnswer, updatePartsArray, updateSuppliersArray,pushResponseName,updateContext };
 
};

export default useTpsContext;